import React, { useEffect, useState } from 'react';
import { Menu, X, Dumbbell } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t.navbar.about,
    href: '#about'
  }, {
    name: t.navbar.services,
    href: '#services'
  }, {
    name: t.navbar.testimonials,
    href: '#testimonials'
  }, {
    name: t.navbar.contact,
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark/95 backdrop-blur-md py-4 border-b border-white/10' : 'bg-transparent py-6'}`} data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between" data-id="element-113">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group" data-id="element-114">
          <Dumbbell className="w-8 h-8 text-brand-accent group-hover:rotate-12 transition-transform duration-300" data-id="element-115" />
          <span className="font-display text-2xl tracking-wider text-white" data-id="element-116">
            COACH<span className="text-brand-accent" data-id="element-117">ALEX</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-118">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-bold uppercase tracking-widest text-gray-300 hover:text-brand-accent transition-colors" data-id="element-119">
              {link.name}
            </a>)}

          {/* Language Switcher */}
          <div className="flex items-center border border-white/20 rounded overflow-hidden" data-id="element-120">
            <button onClick={() => setLanguage('en')} className={`px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors ${language === 'en' ? 'bg-brand-accent text-brand-dark' : 'text-gray-400 hover:text-white'}`} data-id="element-121">
              EN
            </button>
            <button onClick={() => setLanguage('pl')} className={`px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors ${language === 'pl' ? 'bg-brand-accent text-brand-dark' : 'text-gray-400 hover:text-white'}`} data-id="element-122">
              PL
            </button>
          </div>

          <a href="#contact" className="px-5 py-2 bg-brand-accent text-brand-dark font-bold uppercase text-sm tracking-wide hover:bg-brand-accentHover transition-colors" data-id="element-123">
            {t.navbar.startNow}
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center gap-4" data-id="element-124">
          {/* Mobile Language Switcher */}
          <div className="flex items-center border border-white/20 rounded overflow-hidden" data-id="element-125">
            <button onClick={() => setLanguage('en')} className={`px-2 py-1 text-xs font-bold transition-colors ${language === 'en' ? 'bg-brand-accent text-brand-dark' : 'text-gray-400'}`} data-id="element-126">
              EN
            </button>
            <button onClick={() => setLanguage('pl')} className={`px-2 py-1 text-xs font-bold transition-colors ${language === 'pl' ? 'bg-brand-accent text-brand-dark' : 'text-gray-400'}`} data-id="element-127">
              PL
            </button>
          </div>

          <button className="text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-128">
            {isMobileMenuOpen ? <X className="w-8 h-8" data-id="element-129" /> : <Menu className="w-8 h-8" data-id="element-130" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-brand-dark border-b border-white/10 p-4 md:hidden flex flex-col gap-4 shadow-2xl" data-id="element-131">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-lg font-bold uppercase tracking-widest text-gray-300 hover:text-brand-accent py-2 text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-132">
              {link.name}
            </a>)}
        </div>}
    </nav>;
}